import { AppConfig } from '@core/domain/AppConfig.ts';

export const IDB_DELETE_BLOCKED_ERROR =
  'No se pudo eliminar la base local: otra pestaña la mantiene abierta. Cierre las demás pestañas e intente de nuevo.';

/**
 * Deletes the local SQLite IndexedDB database (sql.js export bytes).
 *
 * Rejects after `timeoutMs` instead of hanging forever when another tab keeps
 * the database open (`onblocked` with no `onsuccess`).
 */
export function deleteLocalPuntosEntregaIdb(timeoutMs = 8000): Promise<void> {
  return new Promise((resolve, reject) => {
    let settled = false;
    const finish = (action: () => void): void => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      action();
    };
    const timer = setTimeout(() => {
      finish(() => reject(new Error(IDB_DELETE_BLOCKED_ERROR)));
    }, timeoutMs);
    const req = indexedDB.deleteDatabase(AppConfig.getLocalPuntosEntregaIdbName());
    req.onsuccess = () => finish(resolve);
    req.onerror = () =>
      finish(() => reject(req.error ?? new Error('indexedDB.deleteDatabase failed')));
    req.onblocked = () => {
      /* another tab keeps the DB open; wait until success or timeout */
    };
  });
}
